import { ReactNode } from 'react';
import {
  Button,
  createStyles,
  getSize,
  rem,
  SelectChevronIcon,
} from '@mantine/core';

// same as Input component (https://github.com/mantinedev/mantine/blob/master/src/mantine-core/src/Input/Input.styles.ts#L15)
const sizes = {
  xs: rem(30),
  sm: rem(36),
  md: rem(42),
  lg: rem(50),
  xl: rem(60),
};

const useStyles = createStyles((theme, { labelType }: any, { size }) => ({
  root: {
    // same as Input component (https://github.com/mantinedev/mantine/blob/master/src/mantine-core/src/Input/Input.styles.ts#L101)
    paddingLeft: `calc(${getSize({ size, sizes })} / 3)`,
    paddingRight: `calc(${getSize({ size, sizes })} / 4)`, // Why 4? Because in matches with standart input padding-right :)
    '&:active': { transform: 'none' },
  },
  inner: {
    justifyContent: 'space-between',
  },
  label: {
    fontSize: getSize({ size, sizes: theme.fontSizes }),
    fontWeight: 'normal',
    color:
      labelType === 'placeholder'
        ? theme.fn.placeholderStyles().color
        : theme.black,
  },
}));

type InputSelectProps = {
  placeholder?: ReactNode;
  value?: { value: string; label: string } | null;
  onClick?: () => void;
};

export const InputSelect = ({
  placeholder,
  value,
  onClick,
}: InputSelectProps) => {
  const isShowPlaceholder = !!value;

  const { classes } = useStyles({
    labelType: isShowPlaceholder ? 'value' : 'placeholder',
  });

  return (
    <Button
      variant="default"
      size="lg"
      fullWidth
      rightIcon={<SelectChevronIcon size="md" error={undefined} />}
      classNames={classes}
      onClick={onClick}
    >
      {/* {isShowPlaceholder ? foundLabel : placeholder} */}
      {isShowPlaceholder ? value.label : placeholder}
    </Button>
  );
};
